import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/img/add-image.svg'
import _imports_1 from '@/assets/img/icon/additional-prams-icon.svg'


const _hoisted_1 = { class: "w-full flex justify-center p-5" }
const _hoisted_2 = {
  key: 0,
  class: "w-3/4 relative p-3"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-times text-white w-4 h-4" }, null, -1)
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: " w-full container-add-prams background-grey-lighten-5 cursor-pointer p-5" }
const _hoisted_6 = {
  key: 0,
  class: ""
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "flex w-full justify-center mb-2" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: " w-8 h-8"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-semibold text-center text-sm leading-5" }, " Upload Banner .png/.jpg (1000 x 330) pixel ", -1)
const _hoisted_9 = {
  key: 2,
  class: "w-3/4 relative p-3"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "pi pi-times text-white w-4 h-4" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: " w-full container-add-prams background-grey-lighten-5 p-5 cursor-pointer"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "flex w-full justify-center mb-2" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: " w-8 h-8"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-semibold text-center text-sm leading-5" }, " Drop the files here ... ", -1)
const _hoisted_14 = {
  key: 1,
  class: " w-full container-add-prams background-grey-lighten-5 cursor-pointer p-5"
}
const _hoisted_15 = {
  key: 0,
  class: ""
}
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "flex w-full justify-center mb-2" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: " w-8 h-8"
  })
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-semibold text-center text-sm leading-5" }, " Upload Banner .png/.jpg (1000 x 330) pixel ", -1)
const _hoisted_18 = { class: "detail-voucher-section" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "text-black font-bold text-xl" }, "Detail Voucher", -1)
const _hoisted_20 = { class: "p-5" }
const _hoisted_21 = { class: "grid grid-cols-4 gap-4 items-center mb-5" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold" }, "Type Voucher")
], -1)
const _hoisted_23 = { class: "col-span-3" }
const _hoisted_24 = {
  key: 0,
  style: {"width":"100%"},
  class: "p-error"
}
const _hoisted_25 = { class: "grid grid-cols-4 gap-4 items-center mb-5" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold" }, "Judul Voucher")
], -1)
const _hoisted_27 = { class: "col-span-3" }
const _hoisted_28 = {
  key: 0,
  class: "p-error"
}
const _hoisted_29 = { class: "grid grid-cols-4 gap-4 mb-5" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold" }, "Deskripsi Voucher")
], -1)
const _hoisted_31 = { class: "col-span-3" }
const _hoisted_32 = {
  key: 0,
  class: "p-error"
}
const _hoisted_33 = { class: "grid grid-cols-4 gap-4 items-center mb-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold" }, "Generate Kode Random")
], -1)
const _hoisted_35 = { class: "col-span-3" }
const _hoisted_36 = { class: "md:flex gap-10" }
const _hoisted_37 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_38 = { class: "grid grid-cols-4 gap-4 items-center mb-5" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold hidden" })
], -1)
const _hoisted_40 = { class: "" }
const _hoisted_41 = {
  key: 0,
  class: "gap-10"
}
const _hoisted_42 = {
  key: 0,
  class: "color-primary"
}
const _hoisted_43 = {
  key: 1,
  class: "color-primary font-bold"
}
const _hoisted_44 = { class: "discount-section" }
const _hoisted_45 = /*#__PURE__*/_createVNode("p", { class: "text-black font-bold text-xl" }, "Diskon & Potongan", -1)
const _hoisted_46 = { class: "p-5" }
const _hoisted_47 = { class: "grid grid-cols-4 gap-4 items-center mb-5" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold" }, "Jenis Potongan")
], -1)
const _hoisted_49 = { class: "col-span-3" }
const _hoisted_50 = { class: "flex gap-4" }
const _hoisted_51 = { class: "grid grid-cols-4 gap-4 mb-5 items-center" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold" }, "Diskon & Maks. Potongan")
], -1)
const _hoisted_53 = { class: "col-span-3" }
const _hoisted_54 = { class: "md:flex gap-4 items-center" }
const _hoisted_55 = {
  key: 0,
  class: "p-input-icon-right mt-1 color-blue-grey"
}
const _hoisted_56 = /*#__PURE__*/_createVNode("i", { class: "pi pi-percentage text-sm" }, null, -1)
const _hoisted_57 = { class: "voucher-usage" }
const _hoisted_58 = /*#__PURE__*/_createVNode("p", { class: "text-black font-bold text-xl" }, "Penggunaan Voucher", -1)
const _hoisted_59 = { class: "p-5" }
const _hoisted_60 = { class: "grid grid-cols-4 gap-4 items-center mb-5" }
const _hoisted_61 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold" }, "Jumlah Voucher")
], -1)
const _hoisted_62 = { class: "col-span-3" }
const _hoisted_63 = {
  key: 0,
  class: "grid grid-cols-4 gap-4 items-center mb-5"
}
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold" }, "Jumlah Voucher Digunakan")
], -1)
const _hoisted_65 = { class: "col-span-3" }
const _hoisted_66 = { class: "grid grid-cols-4 gap-4 mb-5 items-center" }
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold" }, "Maks. Penggunaan Tiap Pengguna")
], -1)
const _hoisted_68 = { class: "col-span-3" }
const _hoisted_69 = { class: "grid grid-cols-4 gap-4 mb-5" }
const _hoisted_70 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold mb-2" }, "Penukaran Poin"),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey text-xs" }, "Jumlah poin yang harus dibayarkan oleh pengguna untuk menukarkan poinnya menjadi voucher")
], -1)
const _hoisted_71 = { class: "col-span-3" }
const _hoisted_72 = { class: "additional-params" }
const _hoisted_73 = { class: "flex gap-4 items-center" }
const _hoisted_74 = /*#__PURE__*/_createVNode("p", { class: "text-black font-bold text-xl" }, "Parameter Tambahan", -1)
const _hoisted_75 = {
  key: 0,
  class: "text-black"
}
const _hoisted_76 = {
  key: 1,
  class: "pi pi-plus text-black"
}
const _hoisted_77 = { class: "p-5" }
const _hoisted_78 = {
  key: 0,
  class: " w-full container-add-prams bg-white p-5"
}
const _hoisted_79 = {
  key: 1,
  class: " w-full container-add-prams background-grey-lighten-5 p-5"
}
const _hoisted_80 = /*#__PURE__*/_createVNode("div", { class: "flex w-full justify-center mb-2" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: ""
  })
], -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-semibold text-center text-sm leading-5" }, " Belum Ada Parameter Tambahan ", -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-center text-xs leading-4" }, [
  /*#__PURE__*/_createTextVNode(" tambahkan parameter tambahan jika voucher "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("anda memiliki spesifikasi khusus ")
], -1)
const _hoisted_83 = { class: "on-off" }
const _hoisted_84 = { class: "grid grid-cols-4 gap-4 mb-5 items-center" }
const _hoisted_85 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold" }, "Sembunyikan Ke Pengguna")
], -1)
const _hoisted_86 = { class: "col-span-3" }
const _hoisted_87 = { class: "grid grid-cols-4 gap-4 mb-5 items-center" }
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold" }, "Aktifkan Voucher")
], -1)
const _hoisted_89 = { class: "col-span-3" }
const _hoisted_90 = { class: "flex gap-4" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_92 = {
  class: "flex w-full justify-between items-center px-2 pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_93 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("h6", { class: "font-semibold text-xl text-black" }, "Tambah Parameter Voucher")
], -1)
const _hoisted_94 = { class: "flex gap-4 p-2" }
const _hoisted_95 = /*#__PURE__*/_createVNode("p", { class: "text-base font-semibold" }, "Simpan", -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("p", { class: "text-base font-semibold" }, "Kembali", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Button = _resolveComponent("Button")
  const _component_PramsComponents = _resolveComponent("PramsComponents")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Card = _resolveComponent("Card")
  const _component_AdditionalParamsForm = _resolveComponent("AdditionalParamsForm")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode("form", {
      onSubmit: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)), ["prevent"]))
    }, [
      _createVNode(_component_Card, null, {
        header: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            (_ctx.imgTemp !== null && _ctx.isEdit)
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  (_ctx.imgTemp !== null)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: "flex items-center rounded-full bg-red-500 absolute p-1 cursor-pointer",
                        style: {"right":"0","top":"0","z-index":"10"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imgTemp = null))
                      }, [
                        _hoisted_3
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_4, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("img", {
                        class: "w-full object-cover",
                        src: `${_ctx.linkEnv}${_ctx.imgTemp}`,
                        style: {"max-height":"400px","min-height":"330px"}
                      }, null, 8, ["src"])
                    ])
                  ])
                ]))
              : (_ctx.$store.state.device.isMobile)
                ? (_openBlock(), _createBlock("div", {
                    key: 1,
                    class: " w-full container-add-prams background-grey-lighten-5 cursor-pointer p-5",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCamera()))
                  }, [
                    (_ctx.image.src === null)
                      ? (_openBlock(), _createBlock("div", _hoisted_6, [
                          _hoisted_7,
                          _hoisted_8
                        ]))
                      : (_openBlock(), _createBlock("img", {
                          key: 1,
                          class: "w-full ",
                          src: _ctx.image.src,
                          alt: _ctx.image.name
                        }, null, 8, ["src", "alt"]))
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_9, [
                    (_ctx.image.src !== null)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "flex items-center rounded-full bg-red-500 absolute p-1 cursor-pointer",
                          style: {"right":"0","top":"0","z-index":"10"},
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetImage()))
                        }, [
                          _hoisted_10
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _mergeProps({ class: "w-full" }, _ctx.getRootProps()), [
                      _createVNode("input", _ctx.getInputProps(), null, 16),
                      (_ctx.isDragActive)
                        ? (_openBlock(), _createBlock("div", _hoisted_11, [
                            _hoisted_12,
                            _hoisted_13
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_14, [
                            (_ctx.image.src === null)
                              ? (_openBlock(), _createBlock("div", _hoisted_15, [
                                  _hoisted_16,
                                  _hoisted_17
                                ]))
                              : (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  class: "w-full ",
                                  src: _ctx.image.src,
                                  alt: _ctx.image.name
                                }, null, 8, ["src", "alt"]))
                          ]))
                    ], 16)
                  ]))
          ])
        ]),
        content: _withCtx(() => [
          _createVNode("section", _hoisted_18, [
            _hoisted_19,
            _createVNode("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode("div", _hoisted_23, [
                  _createVNode("div", null, [
                    _createVNode(_component_Dropdown, {
                      id: "voucherType",
                      modelValue: _ctx.v$.type.$model,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.type.$model = $event)),
                      options: _ctx.listType,
                      class: "mt-1",
                      optionLabel: "label",
                      optionValue: "value",
                      placeholder: "Pilih tipe voucher"
                    }, null, 8, ["modelValue", "options"]),
                    ((_ctx.v$.title.$invalid && _ctx.submitted) || _ctx.v$.title.$pending.$response)
                      ? (_openBlock(), _createBlock("small", _hoisted_24, _toDisplayString(_ctx.v$.title.required.$message), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode("div", _hoisted_27, [
                  _createVNode(_component_InputText, {
                    class: "w-full rounded-lg input-primary",
                    modelValue: _ctx.v$.title.$model,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.title.$model = $event))
                  }, null, 8, ["modelValue"]),
                  ((_ctx.v$.title.$invalid && _ctx.submitted) || _ctx.v$.title.$pending.$response)
                    ? (_openBlock(), _createBlock("small", _hoisted_28, _toDisplayString(_ctx.v$.title.required.$message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_29, [
                _hoisted_30,
                _createVNode("div", _hoisted_31, [
                  _createVNode(_component_Textarea, {
                    class: "w-full rounded-lg input-primary",
                    modelValue: _ctx.v$.description.$model,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.description.$model = $event))
                  }, null, 8, ["modelValue"]),
                  (
                      (_ctx.v$.description.$invalid && _ctx.submitted) || _ctx.v$.description.$pending.$response
                    )
                    ? (_openBlock(), _createBlock("small", _hoisted_32, _toDisplayString(_ctx.v$.description.required.$message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_33, [
                _hoisted_34,
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.targetUserOption, (data, index) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "p-field-radiobutton items-center flex gap-1 mb-2 md:mb-0",
                        key: index
                      }, [
                        _createVNode(_component_RadioButton, {
                          id: `targetUser-${index}`,
                          class: "radio-primary",
                          value: data.value,
                          disabled: _ctx.isEdit,
                          modelValue: _ctx.dataForm.targetUser,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataForm.targetUser = $event))
                        }, null, 8, ["id", "value", "disabled", "modelValue"]),
                        _createVNode("label", {
                          class: "color-blue-grey",
                          for: `targetUser-${index}`
                        }, _toDisplayString(data.label), 9, ["for"]),
                        (!data.value)
                          ? (_openBlock(), _createBlock("div", _hoisted_37, [
                              _createVNode(_component_InputText, {
                                maxlength: "15",
                                minlength: "5",
                                type: "text",
                                class: "rounded-lg input-primary",
                                disabled: _ctx.dataForm.targetUser || _ctx.isEdit,
                                modelValue: _ctx.dataForm.kode,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dataForm.kode = $event))
                              }, null, 8, ["disabled", "modelValue"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode("div", _hoisted_40, [
                  (_ctx.dataForm.targetUser)
                    ? (_openBlock(), _createBlock("div", _hoisted_41, [
                        (!_ctx.isEdit)
                          ? (_openBlock(), _createBlock("p", _hoisted_42, " Kode otomatis terbuat saat voucher disimpan "))
                          : (_openBlock(), _createBlock("p", _hoisted_43, _toDisplayString(_ctx.codeGenerate), 1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createVNode("section", _hoisted_44, [
            _hoisted_45,
            _createVNode("div", _hoisted_46, [
              _createVNode("div", _hoisted_47, [
                _hoisted_48,
                _createVNode("div", _hoisted_49, [
                  _createVNode("div", _hoisted_50, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.priceTypeOption, (data, index) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "p-field-radiobutton items-center flex gap-1",
                        key: index
                      }, [
                        _createVNode(_component_RadioButton, {
                          id: `priceType-${index}`,
                          class: "radio-primary",
                          value: data.value,
                          modelValue: _ctx.dataForm.priceType,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dataForm.priceType = $event)),
                          disabled: _ctx.isDisableForm()
                        }, null, 8, ["id", "value", "modelValue", "disabled"]),
                        _createVNode("label", {
                          class: "color-blue-grey",
                          for: `priceType-${index}`
                        }, _toDisplayString(data.label), 9, ["for"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_51, [
                _hoisted_52,
                _createVNode("div", _hoisted_53, [
                  _createVNode("div", _hoisted_54, [
                    (!_ctx.dataForm.priceType)
                      ? (_openBlock(), _createBlock("span", _hoisted_55, [
                          _hoisted_56,
                          _createVNode(_component_InputText, {
                            type: "number",
                            class: "input-primary rounded-lg",
                            min: "0",
                            max: "100",
                            step: "any",
                            modelValue: _ctx.dataForm.discount,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.dataForm.discount = $event)),
                            disabled: _ctx.isDisableForm()
                          }, null, 8, ["modelValue", "disabled"])
                        ]))
                      : (_openBlock(), _createBlock(_component_InputNumber, {
                          key: 1,
                          class: "input-primary rounded-lg mb-2 md:mb-0",
                          mode: "currency",
                          min: 0,
                          currency: "IDR",
                          currencyDisplay: "code",
                          locale: "id-ID",
                          modelValue: _ctx.dataForm.discount,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dataForm.discount = $event)),
                          disabled: _ctx.isDisableForm()
                        }, null, 8, ["modelValue", "disabled"])),
                    _createVNode(_component_InputNumber, {
                      class: "input-primary rounded-lg w-full",
                      mode: "currency",
                      currency: "IDR",
                      currencyDisplay: "code",
                      locale: "id-ID",
                      min: 0,
                      disabled: _ctx.isDisableForm(),
                      modelValue: _ctx.dataForm.maxPotongan,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dataForm.maxPotongan = $event))
                    }, null, 8, ["disabled", "modelValue"])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("section", _hoisted_57, [
            _hoisted_58,
            _createVNode("div", _hoisted_59, [
              _createVNode("div", _hoisted_60, [
                _hoisted_61,
                _createVNode("div", _hoisted_62, [
                  _createVNode(_component_InputNumber, {
                    class: "rounded-lg text-center",
                    showButtons: "",
                    buttonLayout: "horizontal",
                    incrementButtonIcon: "pi pi-plus",
                    decrementButtonIcon: "pi pi-minus",
                    min: 1,
                    disabled: _ctx.isDisableForm(),
                    modelValue: _ctx.dataForm.qty,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dataForm.qty = $event))
                  }, null, 8, ["disabled", "modelValue"])
                ])
              ]),
              (_ctx.isEdit)
                ? (_openBlock(), _createBlock("div", _hoisted_63, [
                    _hoisted_64,
                    _createVNode("div", _hoisted_65, [
                      _createVNode(_component_InputNumber, {
                        class: "rounded-lg text-center",
                        disabled: true,
                        modelValue: _ctx.dataForm.penggunaan,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.dataForm.penggunaan = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_66, [
                _hoisted_67,
                _createVNode("div", _hoisted_68, [
                  _createVNode(_component_InputNumber, {
                    class: "rounded-lg text-center",
                    showButtons: "",
                    buttonLayout: "horizontal",
                    incrementButtonIcon: "pi pi-plus",
                    decrementButtonIcon: "pi pi-minus",
                    min: 0,
                    disabled: _ctx.isDisableForm(),
                    modelValue: _ctx.dataForm.useLimit,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.dataForm.useLimit = $event))
                  }, null, 8, ["disabled", "modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_69, [
                _hoisted_70,
                _createVNode("div", _hoisted_71, [
                  _createVNode(_component_InputNumber, {
                    class: "input-primary rounded-lg min-w-10",
                    min: 0,
                    modelValue: _ctx.dataForm.poin,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.dataForm.poin = $event)),
                    disabled: _ctx.isDisableForm()
                  }, null, 8, ["modelValue", "disabled"])
                ])
              ])
            ])
          ]),
          _createVNode("section", _hoisted_72, [
            _createVNode("div", _hoisted_73, [
              _hoisted_74,
              _createVNode(_component_Button, {
                class: "font-semibold p-button-sm btn-primary",
                onClick: _ctx.addNewPrams,
                disabled: _ctx.isDisableForm()
              }, {
                default: _withCtx(() => [
                  (_ctx.dataFormChoice.length > 0)
                    ? (_openBlock(), _createBlock("p", _hoisted_75, "Edit"))
                    : (_openBlock(), _createBlock("i", _hoisted_76))
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ]),
            _createVNode("div", _hoisted_77, [
              (_ctx.dataFormChoice.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_78, [
                    _createVNode(_component_PramsComponents, {
                      dataSource: _ctx.dataFormChoice,
                      isPopUp: false
                    }, null, 8, ["dataSource"])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_79, [
                    _hoisted_80,
                    _hoisted_81,
                    _hoisted_82
                  ]))
            ])
          ]),
          _createVNode("section", _hoisted_83, [
            _createVNode("div", _hoisted_84, [
              _hoisted_85,
              _createVNode("div", _hoisted_86, [
                _createVNode(_component_InputSwitch, {
                  class: "switch-og",
                  modelValue: _ctx.dataForm.isHidden,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.dataForm.isHidden = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createVNode("div", _hoisted_87, [
              _hoisted_88,
              _createVNode("div", _hoisted_89, [
                _createVNode(_component_InputSwitch, {
                  class: "switch-og",
                  modelValue: _ctx.dataForm.isActive,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.dataForm.isActive = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode("div", _hoisted_90, [
            (_ctx.route.meta.permission.write || _ctx.route.meta.permission.update)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Simpan",
                  class: "font-semibold p-button-sm btn-primary px-10",
                  type: "submit"
                }))
              : _createCommentVNode("", true),
            (_ctx.idVoucher && _ctx.route.meta.permission.delete)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "btn-red font-semibold p-button-sm px-10",
                  label: "Hapus",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.deleteVoucher()))
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              class: "btn-secondary text-black p-button-sm px-10 py-1",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.backPages()))
            }, {
              default: _withCtx(() => [
                _hoisted_91
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ], 32),
    _createVNode(_component_Dialog, {
      visible: _ctx.isShowDialogParams,
      "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => (_ctx.isShowDialogParams = $event)),
      class: "dialog-voucher",
      modal: true,
      dismissableMask: true
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_92, [
          _hoisted_93,
          _createVNode("i", {
            class: "pi pi-times text-black cursor-pointer",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.closeModalAddParams()))
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode("div", _hoisted_94, [
          _createVNode(_component_Button, {
            class: "btn-primary px-10",
            onClick: _ctx.submitAdditionalParams
          }, {
            default: _withCtx(() => [
              _hoisted_95
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "btn-secondary text-black px-10",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.closeModalAddParams()))
          }, {
            default: _withCtx(() => [
              _hoisted_96
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_AdditionalParamsForm, {
          ref: "refFormAddParams",
          onSendPreferredData: _ctx.sendPreferredData,
          isPopUp: true
        }, null, 8, ["onSendPreferredData"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}